import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Download, ArrowRight } from 'lucide-react';
export const PaymentSuccess = () => {
  return <div className="min-h-screen flex items-center justify-center bg-neutral-light p-4" data-id="element-1847">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-neutral-200 p-8 md:p-10 text-center" data-id="element-1848">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15,
        delay: 0.2
      }} className="w-24 h-24 rounded-full bg-success/10 flex items-center justify-center mx-auto mb-6" data-id="element-1849">
          <CheckCircle size={48} className="text-success" data-id="element-1850" />
        </motion.div>

        <h1 className="text-3xl font-serif font-bold text-primary-900 mb-2" data-id="element-1851">
          Payment Successful!
        </h1>
        <p className="text-text-light mb-8" data-id="element-1852">
          Your listing fee has been received. Your property is now in the
          verification queue.
        </p>

        <div className="bg-neutral-50 rounded-2xl p-6 mb-8 text-left border border-neutral-100" data-id="element-1853">
          <div className="space-y-3 text-sm" data-id="element-1854">
            <div className="flex justify-between" data-id="element-1855">
              <span className="text-text-light" data-id="element-1856">Amount Paid</span>
              <span className="font-bold text-text" data-id="element-1857">₦322,500</span>
            </div>
            <div className="flex justify-between" data-id="element-1858">
              <span className="text-text-light" data-id="element-1859">Transaction ID</span>
              <span className="font-medium text-text" data-id="element-1860">TXN-849201</span>
            </div>
            <div className="flex justify-between" data-id="element-1861">
              <span className="text-text-light" data-id="element-1862">Date</span>
              <span className="font-medium text-text" data-id="element-1863">Oct 24, 2023</span>
            </div>
            <div className="flex justify-between" data-id="element-1864">
              <span className="text-text-light" data-id="element-1865">Status</span>
              <span className="font-bold text-success" data-id="element-1866">Completed</span>
            </div>
          </div>
        </div>

        <div className="space-y-3" data-id="element-1867">
          <Link to="/dashboard/seller" className="w-full bg-primary-900 hover:bg-primary-800 text-white py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-lg" data-id="element-1868">
            Go to Dashboard <ArrowRight size={18} data-id="element-1869" />
          </Link>
          <button className="w-full bg-white border border-neutral-200 hover:bg-neutral-50 text-text py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2" data-id="element-1870">
            <Download size={18} data-id="element-1871" /> Download Receipt
          </button>
        </div>
      </motion.div>
    </div>;
};